module.exports = __webpack_public_path__ + "img/qrcode.6881d9d8.svg";